import * as React from "react";
import { Markdown } from "@conserveit/blocks";
import moment from "moment";
import {
  Container,
  ID,
  StyledAvatar,
  StyledArrowBack,
  Summary,
  Updated,
  Description,
  Status,
  Unselected,
} from "./IssueDetails.styles";

const localeSettings = {
  past: "%s old",
};

// TODO: Why is this the way that it is? :(
// @ts-ignore
moment.locale("en", {
  // @ts-ignore
  relativeTime: localeSettings,
});

interface Props {
  issue?: Insite.API.Action;
}

export const IssueDetails: React.FunctionComponent<Props> = ({ issue }) => {
  if (issue === undefined) {
    return (
      <Unselected>
        <h1>Select Action</h1>
      </Unselected>
    );
  }

  return (
    <Container>
      <ID>
        <strong>{issue.key}</strong> {issue.bonfire_status}
      </ID>
      <Summary>{issue.summary}</Summary>
      <Updated>
        <span>Updated {moment(issue.updated).format("DD/MM/YY")}</span>
        <span>{moment(issue.created).fromNow()}</span>
      </Updated>
      <Status>
        <StyledArrowBack priority={issue.priority} />
        {issue.priority}
      </Status>
      <Status>
        <StyledAvatar small /> <span>{issue.responsible}</span>
      </Status>
      {issue.description && (
        <Description>
          <Markdown source={issue.description} />
        </Description>
      )}
    </Container>
  );
};
